import { Phone, Mail, MapPin } from "lucide-react";
import { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import { BsInstagram, BsYoutube } from "react-icons/bs";
import { Link } from "react-router-dom";

const Footer = () => {
  const formRef = useRef();
  const [newsletterMessage, setNewsletterMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleEmailChange = (e) => {
    const emailInput = e.target.value;

    // Email validation regex
    if (!/\S+@\S+\.\S+/.test(emailInput)) {
      setLoading(false);
      setNewsletterMessage("❌ Please enter a valid email address.");
      return;
    } else {
      setLoading(false);
      setNewsletterMessage("");
    }
  };

  // const handleSubscribe = (e) => {
  //   setLoading(true)
  //   e.preventDefault();

  //   const emailInput = formRef.current["user_email"].value;

  //   // Email validation regex
  //   if (!/\S+@\S+\.\S+/.test(emailInput)) {
  //     setLoading(false)
  //     setNewsletterMessage("❌ Please enter a valid email address.");
  //     return;
  //   }

  //   // Show success message
  //   setTimeout(() => {
  //     setLoading(false)
  //      setNewsletterMessage("✅ Thank you for subscribing!");
  //   formRef.current.reset();
  //   }, 1000);
  // };

  const handleSubscribe = async (e) => {
    e.preventDefault();
    setLoading(true);

    const emailInput = formRef.current["user_email"].value;

    // Email validation regex
    if (!/\S+@\S+\.\S+/.test(emailInput)) {
      setLoading(false);
      setNewsletterMessage("❌ Please enter a valid email address.");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("email", emailInput);

      const response = await fetch(
        "https://tissa-api.tissatech.in/newsletter_sendmail.php",
        {
          method: "POST",
          body: formData, // sending like Postman (form-data)
        }
      );

      const data = await response.json();

      if (data.status === "ok") {
        setNewsletterMessage("✅ Thank you for subscribing!");
        formRef.current.reset();
      } else {
        setNewsletterMessage("❌ " + (data.message || "Something went wrong."));
      }

      // Hide after 5 seconds
      setTimeout(() => {
        setNewsletterMessage("");
      }, 3000);
    } catch (error) {
      setNewsletterMessage("❌ Failed to subscribe. Please try again.");
      setTimeout(() => {
        setNewsletterMessage("");
      }, 3000);
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer className="bg-blue-900 text-white bg-opacity-95 relative">
      <div
        className="absolute inset-0 z-0  "
        // style="background-image:url('/images/3302201.png');background-size:cover;background-position:center"
      ></div>
      <div className="container mx-auto px-4 py-8 relative z-10">
        <div className="flex flex-wrap justify-center lg:justify-between -mx-4">
          <div className="w-full md:w-1/3 px-4 mb-6 md:mb-0">
            <div className="flex items-start">
              <div className="bg-primary-light rounded-full p-3 mr-4">
                <Phone className="h-6 w-6 text-white" />
              </div>
              <div>
                <p className="text-gray-300 text-sm">Call Us</p>
                <a
                  href="tel:+1-512-203-7627"
                  className="text-white font-medium hover:text-gray-200 transition"
                >
                  <span className="font-bold">USA</span> +1-512-203-7627
                </a>
              </div>
            </div>
          </div>
          <div className="w-full md:w-1/3 px-4 mb-6 md:mb-0">
            <div className="flex items-start">
              <div className="bg-primary-light rounded-full p-3 mr-4">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-mail h-6 w-6 text-white"
                >
                  <rect width="20" height="16" x="2" y="4" rx="2"></rect>
                  <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"></path>
                </svg>
              </div>
              <div>
                <p className="text-gray-300 text-sm">Write to Us</p>
                <a
                  href="mailto:connect@tissatech.com"
                  className="text-white font-medium hover:text-gray-200 transition"
                >
                  connect@tissatech.com
                </a>
              </div>
            </div>
          </div>
          <div className="w-full md:w-1/3 px-4">
            <div className="flex items-start">
              <div className="bg-primary-light rounded-full p-3 mr-4">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-map-pin h-6 w-6 text-white"
                >
                  <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path>
                  <circle cx="12" cy="10" r="3"></circle>
                </svg>
              </div>
              <div>
                <p className="text-gray-300 text-sm">Office Location</p>
                <p className="text-white font-medium">
                  2001 Timberloch Place, Suite 500 Woodlands, Houston, Texas
                  77380
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container mx-auto px-4 py-10 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <img
              alt="TISSA Technology"
              loading="lazy"
              width="50"
              height="50"
              decoding="async"
              data-nimg="1"
              className="mb-4 bg-white rounded-full border border-gray-300"
              // style="color:transparent"
              src="/assets/images/logos/favicon.png"
            />
            <p className="text-gray-300 mb-4">
              TISSA Technology provides expertise in a wide range of platforms
              and frameworks, delivering superior custom software solutions for
              businesses.
            </p>
            <div className="flex space-x-4 mt-6">
              <a
                href="https://www.facebook.com/tissatech/"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-primary-light hover:bg-white hover:text-primary p-2 rounded-full transition-colors duration-300"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-facebook"
                >
                  <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path>
                </svg>
              </a>
              <a
                href="https://www.linkedin.com/company/tissatech/"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-primary-light hover:bg-white hover:text-primary p-2 rounded-full transition-colors duration-300"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-linkedin"
                >
                  <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path>
                  <rect width="4" height="12" x="2" y="9"></rect>
                  <circle cx="4" cy="4" r="2"></circle>
                </svg>
              </a>
              <a
                href="https://www.instagram.com/tissadigital/"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-primary-light hover:bg-white hover:text-primary p-2 rounded-full transition-colors duration-300"
              >
                <BsInstagram />
              </a>
              <a
                href="https://www.youtube.com/channel/UCZ4SzB9n66H4NpKJEtIQkzw"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-primary-light hover:bg-white hover:text-primary p-2 rounded-full transition-colors duration-300"
              >
                <BsYoutube />
              </a>
            </div>
          </div>
          <div>
            <h3 className="text-xl font-semibold mb-4 text-white">Services</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  className="text-gray-300 hover:text-white transition"
                  to="/services/custom-software-development/"
                >
                  Custom Software Development
                </Link>
              </li>
              <li>
                <Link
                  className="text-gray-300 hover:text-white transition"
                  to="/services/mobile-app-development/"
                >
                  Mobile App Development
                </Link>
              </li>
              <li>
                <Link
                  className="text-gray-300 hover:text-white transition"
                  to="/services/api-development"
                >
                  API Development
                </Link>
              </li>
              <li>
                <Link
                  className="text-gray-300 hover:text-white transition"
                  to="/services/odoo-services/"
                >
                  Odoo Services
                </Link>
              </li>
              <li>
                <Link
                  className="text-gray-300 hover:text-white transition"
                  to="/services/integration/"
                >
                  Integration
                </Link>
              </li>
              <li>
                <Link
                  className="text-gray-300 hover:text-white transition"
                  to="/services/consulting/"
                >
                  IT Consulting
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="text-xl font-semibold mb-4 text-white">
              Quick Links
            </h3>
            <ul className="space-y-2">
              <li>
                <Link
                  className="text-gray-300 hover:text-white transition"
                  to="/about-us/"
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  className="text-gray-300 hover:text-white transition"
                  to="/products/"
                >
                  Products
                </Link>
              </li>
              {/* <li>
                <a
                  className="text-gray-300 hover:text-white transition"
                  href="/our-team/"
                >
                  Our Team
                </a>
              </li> */}
              <li>
                <Link
                  className="text-gray-300 hover:text-white transition"
                  to="/career/"
                >
                  Career
                </Link>
              </li>
              <li>
                <Link
                  className="text-gray-300 hover:text-white transition"
                  to="/contact-us/"
                >
                  Contact Us
                </Link>
              </li>
              {/* <li>
                <a
                  className="text-gray-300 hover:text-white transition"
                  href="/privacy-policy"
                >
                  Privacy Policy
                </a>
              </li>
              <li>
                <a
                  className="text-gray-300 hover:text-white transition"
                  href="/terms-of-service"
                >
                  Terms of Service
                </a>
              </li> */}
            </ul>
          </div>
          <div>
            <h3 className="text-xl font-semibold mb-4 text-white">
              Newsletter
            </h3>
            <p className="text-gray-300 mb-4">
              Subscribe to our newsletter to receive updates on our latest
              services and offerings.
            </p>
            <form ref={formRef} onSubmit={handleSubscribe} className="mt-4">
              <div className="flex flex-col space-y-3">
                <input
                  type="email"
                  name="user_email"
                  placeholder="Your Email Address"
                  onChange={(e) => handleEmailChange(e)}
                  className="px-4 py-3 bg-primary-dark text-black rounded-md focus:outline-none border focus:ring-2 focus:ring-blue-300 placeholder-gray-400"
                  required
                />
                {!loading ? (
                  <button
                    type="submit"
                    className="px-4 py-3 bg-white text-primary hover:bg-gray-100 font-medium text-black rounded-md transition-colors duration-300"
                  >
                    Subscribe
                  </button>
                ) : (
                  <button
                    type="button"
                    className="px-4 py-3 bg-white text-primary font-medium text-black rounded-md"
                  >
                    Subscribing...
                  </button>
                )}
                {newsletterMessage && (
                  <p
                    className={`text-sm font-bold ${
                      newsletterMessage.startsWith("✅")
                        ? "text-green-500"
                        : "text-red-500"
                    }`}
                  >
                    {newsletterMessage}
                  </p>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className="border-t border-primary-light bg-primary-dark py-4 relative z-10">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-center md:text-left text-gray-300 text-sm">
              Copyright © 2025 TISSA Technology. All Rights Reserved.
            </p>
            <div className="flex space-x-4 mt-3 md:mt-0">
              <Link
                className="text-gray-300 hover:text-white text-sm transition"
                to="/privacy-policy"
              >
                Privacy Policy
              </Link>
              <Link
                className="text-gray-300 hover:text-white text-sm transition"
                to="/terms-of-service"
              >
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
